import Axios from 'axios';
import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { BulkDistrItem, DistrModerationState } from './types';

export const actions: ActionTree<DistrModerationState, RootState> = {
  getBulkDistrList: ({commit}, data) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({url: '/acapi/moderation', params: data})
        .then(resp => {
          commit('setBulkDistrList', resp.data.bulks);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        })
        .finally(() => commit('setLoading', false));
    });
  },
  getBulkDistrItem: ({commit}, id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({url: `/acapi/moderation/${id}`})
        .then(resp => {
          let bulkDistrItem = <BulkDistrItem> resp.data;
          bulkDistrItem.id = id;
          commit('setBulkDistrItem', bulkDistrItem);
          resolve(bulkDistrItem);
        })
        .catch(err => {
          reject(err);
        })
        .finally(() => commit('setLoading', false));
    });
  },
  allowBulkDistr: ({commit, dispatch}, id: number) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({
        method: 'get',
        url: `/acapi/moderation/${id}/accept`
      })
        .then((resp: any) => {
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => commit('setLoading', false));
    });
  },
  denyBulkDistr: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({
        method: 'put',
        url: `/acapi/moderation/${data.id}/reject`,
        data: data
      })
        .then((resp: any) => {
          dispatch('getBulkDistrList');
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => commit('setLoading', false));
    })
  },

};
